import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { createDeliveryChargeTemplateValidation } from "../../utils/validationSchema";
import Form from "../../layouts/Form";
import TextField from "../Reusable/Form/TextInput";
import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/Form/ComboboxInput";

const CreateDeliveryChargeTemplate = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(createDeliveryChargeTemplateValidation),
  });
  const { handleCreate, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <ComboboxInput
          label={"Delivery Charge Template"}
          placeholder={"Search Delivery Charge Template"}
          url={APIS.DELIVERY_CHARGE_TEMPLATE}
          props={{}}
          queryKey={"delivery-charge-template"}
          register={register("previous_delivery_charge_template")}
          errors={errors?.warehouse}
          name={"previous_delivery_charge_template"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
       <TextField
        label={"Name"}
        register={register("name")}
        errors={errors?.name}
      />
    </Form>
  );
};


export default CreateDeliveryChargeTemplate
